import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { DecksView } from '@/features/decks/DecksView.js';
import { ensureDecksEnabled } from '@/features/decks/guard.js';

/**
 * Index route for `/decks`. Defined as an index (not `decks.tsx`) so the list
 * and the `/decks/$id` detail are SIBLINGS under an implicit `/decks` parent —
 * otherwise a non-index `decks.tsx` becomes the detail route's parent and
 * (without an <Outlet/>) keeps rendering the list when navigating to a child.
 */
export const Route = createFileRoute('/decks/')({
  component: DecksPage,
  beforeLoad: () => ensureDecksEnabled(),
});

function DecksPage(): JSX.Element {
  return <DecksView />;
}
